// extracted by mini-css-extract-plugin
export default {"liste":"Report_liste__utTfj","controls":"Report_controls__DauQ9"};